export const keyToCoords = (key) => {
  return key.split(',').map(Number);
}